module.exports = __webpack_public_path__ + "static/img/logo-new.64ac3bbf.png";